import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const PayIDPanelStyled = styled.section({
  fontFamily: font.family.primary,

  p: {
    textAlign: 'left',
    margin: 0,
    ...font.size.md,
  },

  '> header p': {
    color: colors.neutral[800],
  },
})

export const MissingPayIDCardStyled = styled.div({
  alignItems: 'center',
  backgroundColor: colors.lavender[900],
  borderRadius: radius.lgx1,
  columnGap: spacing.big,
  display: 'grid',
  gridTemplateColumns: '7.6rem 1fr',
  marginTop: spacing.md,
  padding: `${spacing.md} ${spacing.bigx1}`,

  p: {
    color: colors.white,
    marginBottom: spacing.sm,
  },

  svg: {
    display: 'inline-block',
  },

  a: {
    color: 'inherit',
  },
})

export const InfoListStyled = styled.dl({
  alignItems: 'center',
  color: colors.neutral[900],
  display: 'grid',
  gap: spacing.sm,
  gridAutoRows: '5rem',
  gridTemplateColumns: 'minmax(0, max-content) 1fr',
  margin: 0,
  marginTop: spacing.md,
  ...font.size.lg,

  dt: {
    fontWeight: font.weight.semibold,
    display: 'flex',
    alignItems: 'center',
    gap: spacing.smx2,
  },

  dd: {
    margin: 0,
  },
})
